import Vue from 'vue';
import store from '../../vuex/store';
import events from './../../events/events'
import Echo from 'laravel-echo';
import * as Sentry from '@sentry/vue';

const state =
{
    authenticated: false,
    token: null, // this is the X-CSRF-TOKEN
    fake: false,
};

const actions =
{
    checkAuth ({commit})
    {
        var token = localStorage.getItem('auth_token');

        if (token) {
            commit('LOGIN', {
                token
            });
        } else {
            store.dispatch('current/reset');
            commit('app/SET_READY', true, { root: true });
        }
    },

    login ({commit}, payload)
    {
        Vue.http.post('/api/auth/login', {
            email: payload.email,
            password: payload.password,
            token: payload.token,
            locale: store.state.meta.lang,
            mobile: location.hostname.match('mobile') ? true : false // this is needed in order to send a long-lasting cookie in the response
        })
        .then(response =>
        {
            if (location.hostname.match('beta') && ! response.data.beta)
            {
                // beta access not allowed
                commit('LOGOUT', {
                    // callback needs to be wrapped in a function, otherwise it will be triggered immediately,
                    // since we are including the response object in the function parameter
                    callback: (payload.error) ? () => { payload.error(response) } : null
                });

                return;
            }

            try {
                localStorage.setItem('auth_token', response.data.csrfToken);
            }
            catch (e)
            {
                captureMessage('Could not write [auth_token] to localStorage.', { level: 'info' });

                alert('Your web browser does not support storing settings locally. In Safari, the most common cause of this is using "Private Browsing Mode". Some settings may not save or some features may not work properly for you.');
            }

            commit('LOGIN', {
                token: response.data.csrfToken,
                callback: (payload.success) ? payload.success : null
            });
        })
        .catch(error =>
        {
            commit('LOGOUT', {
                // callback needs to be wrapped in a function, otherwise it will be triggered immediately,
                // since we are including the response object in the function parameter
                callback: (payload.error) ? () => { payload.error(error.response) } : null
            });
        });
    },

    autoLogin ({commit}, payload)
    {
        try {
            localStorage.setItem('auth_token', payload.csrfToken);
        }
        catch (e)
        {
            captureMessage('Could not write [auth_token] to localStorage.', { level: 'info' });

            alert('Your web browser does not support storing settings locally. In Safari, the most common cause of this is using "Private Browsing Mode". Some settings may not save or some features may not work properly for you.');
        }

        commit('LOGIN', {
            token: payload.csrfToken,
            callback: (payload.callback) ? payload.callback : null
        });
    },

    // invoke fake user limitations
    fake ({commit})
    {
        commit('FAKE');
    },

    // remove fake user limitations
    real ({commit})
    {
        commit('REAL');
    },

    logout ({commit}, callback)
    {
        Vue.http.post('/api/auth/logout')
        .then(response =>
        {
            commit('LOGOUT', {
                callback: (callback) ? callback : null
            });
        })
        .catch(error =>
        {
            commit('LOGOUT', {
                callback: (callback) ? callback : null
            });
        });
    },
};

const mutations =
{
    LOGIN (state, payload)
    {
        state.authenticated = true;
        state.token = payload.token;

        window.Pusher = require('pusher-js');

        window.Echo = new Echo({
            broadcaster: 'pusher',
            key: (process.env.NODE_ENV == 'development' || location.hostname.match('test')) ? '5ba6032fb1b5bebd6c9c' : 'c489323fb6f37412c460',
            authEndpoint: '/api/auth/broadcast',
            namespace: 'Onduro.Events',
            cluster: 'eu',
            csrfToken: payload.token,
            encrypted: true
        });

        // set axios headers
        Vue.http.defaults.headers.common['X-CSRF-TOKEN'] = payload.token;
        Vue.http.defaults.headers.common['X-ONDURO-MOBILE'] = location.hostname.match('mobile') ? true : false;

        setSocketId();

        // adds overflow:hidden to body
        document.body.classList.add('in-app');

        if (localStorage.getItem('fake')) state.fake = true;

        store.dispatch('app/init', payload.callback);

        store.dispatch('chat/setUnreadChats');

        // replace 'ONDURO | Login'
        document.title = 'ONDURO';
    },

    FAKE (state)
    {
        if (window.Intercom)
        {
            Intercom('shutdown');
            window.Intercom = null;
        }

        state.fake = true;
        localStorage.setItem('fake', true);
    },

    REAL (state)
    {
        state.fake = false;
        localStorage.removeItem('fake');
    },

    LOGOUT (state, payload)
    {
        state.authenticated = false;
        state.token = null;
        state.fake = false;

        Vue.university.close();

        Vue.http.defaults.headers.common['X-CSRF-TOKEN'] = '';
        Vue.http.defaults.headers.common['X-ONDURO-MOBILE'] = '';
        Vue.http.defaults.headers.common['X-Socket-ID'] = '';

        localStorage.removeItem('fake');
        localStorage.removeItem('auth_token')

        if (Sentry)
        {
            Sentry.configureScope(scope => scope.clear());
        }

        if (window.Echo) 
        {
            window.Echo.disconnect();
            window.Echo = null;

            events.$emit('auth.loggedout');
        }

        if (window.Intercom) Intercom('shutdown');

        // removes overflow:hidden to body
        document.body.classList.remove('in-app');

        store.commit('app/SET_READY', true, { root: true });

        if (payload.callback) payload.callback();
    },
};

function setSocketId()
{
    setTimeout(() =>
    {
        let socketId = window.Echo.socketId();

        if (socketId) {
            Vue.http.defaults.headers.common['X-Socket-ID'] = socketId;
        } else {
            // try again...
            setSocketId();
        }
    }, 200);
}

export default
{
    namespaced: true,
    state,
    actions,
    mutations
};



// WEBPACK FOOTER //
// ./src/js/vuex/modules/auth.js